<template>
  <div class="dashboard-effectiveness">
    <div class="page-header">
      <div class="page-header-title">
        评分
      </div>
      <div class="page-header-subinfo">
        <!-- <div>
          <i class="iconfont icon-huiyizhihangkanban"></i>会议执行看板
        </div> -->

      </div>
    </div>
    <div class="page-contain">
      <div class="search-content-main">
          <el-form class="search-content-main-fields">
              <el-form-item>
                  <el-select class="search-content-main-fields" placeholder="请选择" v-model="searchMainData.year" @change="handleMainSearch()">
                    <el-option v-for="item in baseDataRecords.Year" :key="item.id" :value="item.id" :label="item.yearName">
                    </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select class="search-content-main-fields" placeholder="请选择" v-model="searchMainData.season" @change="handleMainSearch()">
                    <el-option value="" label="全部季度"></el-option>
                    <el-option v-for="item of 4" :key="item" :value="item" :label="'第'+item+'季'">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select class="search-content-main-fields" placeholder="请选择" v-model="searchMainData.meetingSystem" @change="handleMainSearch()">
                    <el-option value="" label="全部系统"></el-option>
                    <el-option v-for="item in baseDataRecords.MeetingSystem" :key="item.value" :value="item.value" :label="item.text">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select class="search-content-main-fields" placeholder="请选择" v-model="searchMainData.departId" @change="medicalFieldArr=[''];teamFieldArr=[''];searchMainData.medicalField='';strategyKeynoteArr=[''];handleMainSearch()">
                    <el-option value="" label="全部部门"></el-option>
                    <el-option v-for="item in baseDataRecords.Depart" :key="item.id" :value="item.id" :label="item.departName">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select multiple class="search-content-main-fields" placeholder="请选择" v-model="medicalFieldArr" @change="teamFieldArr=[''];strategyKeynoteArr=[''];handleMainSearch()">
                    <el-option value="" label="全部Franchise/DA"></el-option>
                    <el-option v-for="item in getMedicalFieldArray(searchMainData.departId, true)" :key="item.id" :value="item.id" :label="item.medicalFieldName">
                    </el-option>
                  </el-select>
              </el-form-item>
            <el-form-item>
              <el-select filterable multiple class="search-content-main-fields" placeholder="请选择" v-model="teamFieldArr" @change="handleMainSearch()">
                <el-option value="" label="全部团队"></el-option>
                <el-option v-for="item in getTeamArray(searchMainData.departId, medicalFieldArr, true)" :key="item.id" :value="item.id" :label="item.teamName">
                </el-option>
              </el-select>
            </el-form-item>
              <el-form-item>
                  <el-select filterable multiple class="search-content-main-fields" placeholder="请选择（可搜索）" v-model="productIdArr" @change="strategyKeynoteArr=[''];handleMainSearch()">
                    <el-option value="" label="全部产品"></el-option>
                    <el-option v-for="item in baseDataRecords.Product" :key="item.id" :value="item.id" :label="item.productName">
                    </el-option>
                  </el-select>
              </el-form-item>
          </el-form>
          <el-form class="search-content-main-fields">
            <el-form-item>
              <el-select filterable multiple class="search-content-main-fields" style="width: 0.797rem" placeholder="请选择（可搜索）" v-model="strategyKeynoteArr" @change="handleMainSearch()">
                <el-option value="" label="全部策略重点"></el-option>
                <el-option v-for="item in filterStrategy" :key="item.id" :value="item.id" :label="item.keynote">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
                <el-select class="search-content-main-fields" style="width: 0.797rem" placeholder="请选择" v-model="searchMainData.meetingModality" @change="handleMainSearch()">
                  <el-option value="" label="全部会议形式"></el-option>
                  <el-option v-for="item in baseDataRecords.MeetingModality" :key="item.value" :value="item.value" :label="item.text">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select class="search-content-main-fields" style="width: 0.797rem" placeholder="请选择" v-model="searchMainData.meetingProp" @change="searchMainData.meetingType='';handleMainSearch()">
                  <el-option value="" label="全部会议性质"></el-option>
                  <el-option v-for="item in meetingPropAndTypeArrays.selectMeetingProp" :key="item.itemValue" :value="item.itemValue" :label="item.itemText">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
              <el-select class="search-content-main-fields" style="width: 0.797rem" placeholder="请选择" v-model="searchMainData.meetingType" @change="handleMainSearch()">
                <el-option value="" label="全部A1会议类型"></el-option>
                <el-option v-for="item in filterMeetingType" :key="item.itemValue" :value="item.itemValue" :label="item.itemText">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select class="search-content-main-fields" style="width: 0.797rem" placeholder="请选择" v-model="searchMainData.meetingGsdType" @change="handleMainSearch()">
                <el-option value="" label="全部GSD项目类型"></el-option>
                <el-option v-for="item in baseDataRecords.MeetingGsdType" :key="item.value" :value="item.value" :label="item.text">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select class="search-content-main-fields" style="width: 0.797rem" placeholder="请选择" v-model="searchMainData.meetingGsdSubType" @change="handleMainSearch()">
                <el-option value="" label="全部GSD细项"></el-option>
                <el-option v-for="item in MeetingGsdSubTypes" :key="item.value" :value="item.value" :label="item.text">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
      </div>
      <div class="charts-row">
        <div class="chart chart-full">
          <div class="yAxisLabel">K</div>
          <div class="xAxisLabel">评分</div>
          <div class="title"><i class="iconfont icon-yusuan"></i>预算</div>
          <div>
            <common-echars
              chartClass="chart-class-1"
              :dataset-dimensions="['评分','预算']"
              :dataset-source="data1"
              :option="option1"
              ref="chart1"
            >
            </common-echars>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dashboardApi from '@/api/dashboard/index';
import application from '@/api/meetingplan/application';
import { mapGetters, mapActions } from 'vuex';
import * as orgUtil from '@/util/organizationUtil'

export default {
  data() {
    return {
      medicalFieldArr: [''],
      teamFieldArr: [''],
      productIdArr: [''],
      strategyKeynoteArr: [''],
      searchMainData: {
        year: '',
        season: 1,
        meetingSystem: '',
        departId: '',
        medicalFieldList: '',
        teamFieldList: '',
        productIdList: '',
        strategyKeynoteList: '',
        meetingModality: '',
        meetingType: '',
        meetingProp: '',
        meetingGsdType: '',
        meetingGsdSubType: '',
      },
      meetingPropAndTypeArrays: {
        selectMeetingProp:[], //可选的会议性质
        popMeetingType:[], //推广的会议类型绑定
        nopopMeetingType: [], //非推广的会议类型绑定
        meetingPropType: [] //推广+非推广的会议类型绑定
      },
        //评分
      data1: [],
      option1: {
        grid: {
          left:40,
          right: 100,
          top: 30
        },
        tooltip: {
          trigger: 'item',
          enterable: true,
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          textStyle: {
            color: 'rgba(255, 255, 255, 1)',
          },
          formatter: (params) => {
            let budgetScore = params.value['预算合评分'];

            let info = '';
            for (const data of this.data1) {
              if(data['预算合评分'] == budgetScore) {
                info += info? '<br/>' : '';
                info += `<div style="display:flex">评分：　　　<div style="width: 120px;white-space: normal;">${data['评分']}</div></div>`;
                info += `<div style="display:flex">预算：　　　<div style="width: 120px;white-space: normal;">${data['预算']}K</div></div>`;
                info += `<div style="display:flex">会议名称：　<div style="width: 120px;white-space: normal;">${data['会议名称']}</div></div>`;
                info += `<div style="display:flex">活动负责人：<div style="width: 120px;white-space: normal;">${data['活动负责人']}</div></div>`;
                info += `<div style="display:flex">策略重点：　<div style="width: 120px;white-space: normal;">${data['策略重点']}</div></div>`;
                info += `<div style="display:flex">会议形式：　<div style="width: 120px;white-space: normal;">${data['会议形式']}</div></div>`;
                info += `<div style="display:flex">会议类型：　<div style="width: 120px;white-space: normal;">${data['会议类型']}</div></div>`;
              }
            }

            info = '<div style="max-height: 220px;overflow-y: auto;padding-right: 5px;">' + info +'</div>'

            return info;
          }
        },
        xAxis: {
          min: 0
        },
        yAxis: {
          axisTick: {
            show: false
          }
        },
        series: [
          {type:'scatter',symbolSize: 16,},
        ]
      },
    }
  },
  watch: {
    'medicalFieldArr'(newVal, oldVal) {
      this.do(newVal, oldVal, 'medicalFieldArr');
    },
    'teamFieldArr'(newVal, oldVal) {
      this.do(newVal, oldVal, 'teamFieldArr');
    },
    'productIdArr'(newVal, oldVal) {
      this.do(newVal, oldVal, 'productIdArr');
    },
    'strategyKeynoteArr'(newVal, oldVal) {
      this.do(newVal, oldVal, 'strategyKeynoteArr');
    },
  },
  computed: {
    ...mapGetters(['userInfo','baseDataRecords']),
    MeetingGsdSubTypes() {
      return this.baseDataRecords['MeetingGsdTypeSub' + this.searchMainData.meetingGsdType] || [];
    },
    filterMeetingType() {
      if(!this.searchMainData.meetingProp) {
            let tempAll = [];
            if(JSON.stringify(this.meetingPropAndTypeArrays) !== '{}') {
              this.meetingPropAndTypeArrays.popMeetingType.forEach(m => {
                if(!tempAll.some(t => t.itemValue == m.itemValue)) {
                  tempAll.push(m);
                }
              })
              this.meetingPropAndTypeArrays.nopopMeetingType.forEach(m => {
                if(!tempAll.some(t => t.itemValue == m.itemValue)) {
                  tempAll.push(m);
                }
              })
              this.meetingPropAndTypeArrays.meetingPropType.forEach(m => {
                if(!tempAll.some(t => t.itemValue == m.itemValue)) {
                  tempAll.push(m);
                }
              })
            }
            return tempAll;
        }
        switch(this.basedataGetName('MeetingProp',this.searchMainData.meetingProp)) {
            case '推广':
                return this.meetingPropAndTypeArrays.popMeetingType;
            case '非推广':
                return this.meetingPropAndTypeArrays.nopopMeetingType;
            default:
                return this.meetingPropAndTypeArrays.meetingPropType;
        }
    },
    filterStrategy() {
        let temp = [];
        let productIds = this.searchMainData.productId;
        this.baseDataRecords.Strategy.forEach(strategy => {
            if(this.searchMainData.departId && this.searchMainData.departId != strategy.departId){
                return;
            }
            if(this.searchMainData.medicalField && this.searchMainData.medicalField != strategy.medicalField){
                return;
            }
            if(productIds && productIds.indexOf(strategy.productId) < 0){
                return;
            }

            temp.push(strategy);
        })

        return temp;
    },
  },
  methods: {
    ...mapActions(['initBaseDataByTypes']),
    getMedicalFieldArray(departId, independ) {
      return orgUtil.franchiseArray(departId, independ);
    },
    getTeamArray(departId, medicalFieldArray, independ) {
      return orgUtil.teamArrayByArray(departId, medicalFieldArray, independ);
    },
    do(newVal, oldVal, field) {
      if (oldVal.indexOf('') >= 0 && (newVal.indexOf('') >= 0 && newVal.length > 1)) {
        this[field].splice(this[field].indexOf(''), 1);
      } else if ((oldVal.indexOf('') < 0 && newVal.indexOf('') >= 0) || newVal.length == 0) {
        this[field] = [''];
      }
    },
    trimSpace(array) {
      for (let i = 0; i < array.length; i++) {
        //这里为过滤的值
        if (array[i] == '' || array[i] == null || typeof (array[i]) == "undefined" || array[i] == ' ') {
          array.splice(i, 1);
          i = i - 1;
        }
      }
      return array;
    },
    handleArrar4All(arrName) {
      if(this[arrName].length > 0 && this[arrName][this[arrName].length-1] == '') {
        this[arrName] = ['']
      }
    },
    handleMainSearch() {
      this.handleArrar4All('medicalFieldArr')
      this.handleArrar4All('teamFieldArr')
      this.handleArrar4All('productIdArr')
      this.handleArrar4All('strategyKeynoteArr')
      
      this.searchMainData.medicalFieldList = this.trimSpace(JSON.parse(JSON.stringify(this.medicalFieldArr))).toString();
      this.searchMainData.teamFieldList = this.trimSpace(JSON.parse(JSON.stringify(this.teamFieldArr))).toString();
      this.searchMainData.productIdList = this.trimSpace(JSON.parse(JSON.stringify(this.productIdArr))).toString();
      this.searchMainData.strategyKeynoteList = this.trimSpace(JSON.parse(JSON.stringify(this.strategyKeynoteArr))).toString();
      dashboardApi.effectiveness(this.searchMainData)
          .then(res => {
            this.data1 = [];
            res.forEach(el => {
              el['预算'] = parseFloat((el['预算']/1000).toFixed(2));
              this.data1.push(el);
            })

             this.$nextTick(() => {
                this.$refs['chart1'].chartChange();
             });
          })
    },
  },
  mounted() {
    this.searchMainData.year = (new Date()).getFullYear();

    this.initBaseDataByTypes(['Depart','MedicalField','Product','Year', 'MeetingSystem', 'Strategy','MeetingModality','MeetingType','MeetingProp'])
        .then(() => {
          application.queryMeetingPropAndTypeSelect()
                  .then(res => {
                    this.meetingPropAndTypeArrays = res;
                    this.handleMainSearch();
                  })
        })
  }
};
</script>

<style lang="less" scoped>
  .page-header {
    padding: 8px 0;
    margin-top: -24px;
    font-size: @breadcrumbCurrentFontSize;
    font-weight: bold;
    color: @contentFontColor;
    line-height: 32px;
    height: 48px;
    display: flex;
    align-items: center;

    &-title {
      font-weight: 400;
    }

    &-subinfo {
      height: 32px;
      line-height: 32px;
      margin-left: auto;
      font-weight: 400;
      font-size: 14px;
      color: #0B41CD;
      display: flex;

      i {
        margin-right: 8px;
      }

      &-role {
        width: 180px;

        label {
          margin-right: 10px;
          color: @contentFontColor;
        }

        div {
          width: 120px;
        }
      }
    }
  }
  .search-content-main {
    display: inline-block;
    margin-bottom: 6px;

    .search-content-main-fields {
      float:left;
      display: flex;

      .el-form-item + .el-form-item {
        margin-left: 16px;
      }

      &-year {
        width: 120px;
      }

      &-medicalField {
        width: 180px;
      }
      &-departId {
        width: 180px;
      }
    }

    .search-content-main-fields + .search-content-main-fields {
      margin-top: 6px;
    }
  }

  .search-content-other {
    display: flex;
    height: 56px;
    background: #FFFFFF;
    border-radius: 4px;
    margin-bottom: 12px;
    position: relative;

    &-rate-types {
      display: flex;
      margin-left: 24px;

      &-item {
        line-height: 56px;
        height: 56px;
        font-size: @subSubFontSize;
        color: @subSubFontColor;
        width: 80px;
        text-align: center;
        cursor: pointer;
      }

      &-item.active {
        color: @mainColor;
        border-bottom: 3px solid @mainColor;
      }
    }

    &-distribute-types {
      display: flex;
      height: 32px;
      line-height: 32px;
      width: 128px;
      background-color: rgb(232, 234, 236);
      border-radius: 16px;
      margin-top: 12px;
      position: absolute;
      right: 24px;

      &-item {
        width: 64px;
        height: 32px;
        line-height: 32px;
        font-size: @subSubFontSize;
        color: @subSubFontColor;
        border-radius: 16px;
        text-align: center;
        cursor: pointer;
      }

      &-item.active {
        background-color: @mainColor;
        color: #ffffff;
      }
    }
  }

  .charts-row {
    display: flex;
    position: relative;

    .chart {
      height: 520px;
      width: 592px;
      background: #fff;

      .title {
        color: @subSubFontColor;
        font-size: 18px;
        margin: 15px 0 0 24px;

        i {
          font-size: 16px;
          margin-right: 6px;
          color: rgba(11, 65, 205, 0.5);
        }
      }

      .yAxisLabel {
        font-size: 14px;
        position: absolute;
        left: 60px;
        top: 50px;
      }

      .xAxisLabel {
        font-size: 14px;
        position: absolute;
        right: 30px;
        bottom: 40px;
      }
    }

    .chart-full {
      width: 100%
    }

    .chart-right {
      margin-left: 16px
    }

    .search-content-trend {
      position: absolute;
      right: 24px;
      top: 52px;
      display: flex;
      z-index: 200;

      &-item {
        width: 60px;
        height: 24px;
        border: 1px solid #999999;

        font-weight: @contentFontWeight;
        color: @contentFontColor;
        font-size: 12px;
        text-align: center;
        line-height: 24px;
        cursor: pointer;
      }

      &-item:first-child {
        border-radius: 4px 0 0 4px;
      }

      &-item:last-child {
        border-radius: 0 4px 4px 0;
      }

      &-item.active {
        border-color: @mainColor;
        color: @mainColor;
      }

      .search-content-trend-item + .search-content-trend-item {
        margin-left: -1px;
      }

      .search-content-trend-item.active + .search-content-trend-item {
        border-left-color: @mainColor;
      }
    }
  }

  .charts-row + .charts-row {
    margin-top: 17px;
  }

  .gauge-legend {
    display: flex;
    margin: 16px 0 0 24px;
    font-size: 12px;
    color: @contentFontColor;

    &-value {
      display: flex;
      margin-right: 12px;
      div{
        height: 9px;
        width: 9px;
        border-radius: 4.5px;
        margin: 2px 8px 0 0;
      }
    }

    &-value-1 {
      div {
        background-color: #2D82F0;
      }
    }

    &-value-2 {
      div {
        background-color: #E8EAEC;
      }
    }

    &-value-3 {
      div {
        background-color: #0B41CD;
      }
    }
  }

  .axis-label {
    height: 0px;
    &-0 {
      position: relative;
      top: 145px;
      left: 75px;
      font-size: 14px;
      color: rgba(0,0,0,0.45);
    }
    &-100 {
      position: relative;
      top: 145px;
      left: 195px;
      font-size: 14px;
      color: rgba(0,0,0,0.45);
    }
    &-remain {
      position: relative;
      top: 115px;
      left: 170px;
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      width: 36px;
    }
  }

  .message-info {
    margin-top: -35px;
    display: flex;
    height: 40px;
    font-size: 12px;
    color: @subFontColor;
    line-height: 20px;
    div {
      margin: 0 auto;
    }
  }

</style>

<style lang="less">
.search-content-main-fields{
  .el-tag--info {
    max-width: 140px;
    min-width: 45px;
    padding-right: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    .el-tag__close{
      position: absolute;
      right: -1px;
      top: 5px;
    }
  }
}
  .dashboard-effectiveness {
      .chart-class-1 {
          margin: 16px 24px;
          height: 500px;
          width: 100%;
      }
  }
</style>



// WEBPACK FOOTER //
// index-old.vue?60d7afe5